import ForgotPasswordPage from './ForgotPasswordPage';
export default ForgotPasswordPage;



// WEBPACK FOOTER //
// ./src/modules/onboarding/pages/forgot-password/index.js